import { Component, EventEmitter, Output, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

import { NotificationSearchForm } from '../../models/notification-search.model';
import { DropdownOption } from '@cms/shared-library';
import { WorkerService } from 'src/app/services/worker-service/worker.service';

@Component({
    selector: 'app-filter-sort-popup',
    templateUrl: './filter-sort-popup.component.html',
    styleUrls: ['./filter-sort-popup.component.scss'],
    standalone: false
})
export class FilterSortPopupComponent implements OnInit  {
    currentLang: string = 'en';
    notificationSearchForm: NotificationSearchForm = new NotificationSearchForm();
    sortingOptions: DropdownOption[] = [new DropdownOption('Newest to oldest', 'Du plus récent au plus ancien', 'Newest to oldest',), new DropdownOption('Oldest to newest', 'Du plus ancien au plus récent', 'Oldest to newest')];
    notificationStatuses: DropdownOption[] = [new DropdownOption('All', 'Tous', 'All'), new DropdownOption('Unread', 'Non lu', 'Unread')];
    @Output() applyFilters = new EventEmitter<NotificationSearchForm>();

    constructor(public datePipe: DatePipe,
        public dialogRef: MatDialogRef<FilterSortPopupComponent>,
        public translateService: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if (data.searchForm) {
            this.notificationSearchForm = data.searchForm;
            if (this.notificationSearchForm.notificationStatus == ''){
                this.notificationSearchForm.notificationStatus = 'All'
            }
        } else {
            this.initSearchForm();
        }
        this.currentLang = translateService.currentLang
        this.datePipe = new DatePipe(this.currentLang == 'en' ? 'en-CA' : 'fr-CA')
        translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);
    }

    ngOnInit(): void {
    }

    onApplyFilters() {
        this.applyFilters.emit(this.notificationSearchForm);
        this.dialogRef.close(this.notificationSearchForm);
    }

    closeDialog() {
        this.dialogRef.close(null);
    }

    initSearchForm() {
        this.notificationSearchForm = new NotificationSearchForm();
        this.notificationSearchForm.notificationStatus = 'All';
        this.notificationSearchForm.sortingOption = 'Newest to oldest';
    }

    StartDateChange(a: any) {
        this.notificationSearchForm.fromDate = (a == '' ? null : a);
    }

    EndDateChange(a: any) {
        this.notificationSearchForm.toDate = a == '' ? null : a;
    }

    ValidStartandEndDate() {
        if (!this.notificationSearchForm.fromDate && !this.notificationSearchForm.toDate)
            return false;
        else
            return true;
    }

}